import { useState } from 'react';
import { GET, GET_CUSTOMER_FULL_SEARCH } from '../../../services';
import { useMutation } from '@tanstack/react-query';

export const useGetCustomerFull = ({ handleSubmit }) => {
  const [data, setData] = useState([]);

  const { isPending, mutate: onSearchFull } = useMutation({
    mutationFn: async (searchParamState) => {
      const { search } = searchParamState;
      const response = await GET(
        GET_CUSTOMER_FULL_SEARCH({
          search: search || '',
        }),
      );
      return response.result || [];
    },
    onSuccess: (response) => {
      setData(response);
    },
  });

  const onFetchFull = () =>
    handleSubmit((values) => {
      return onSearchFull(values);
    })();

  return { dataSource: data, setData, onSearchFull, loading: isPending, onFetchFull };
};
